import { IdentityApi, createApiRef } from '@backstage/core-plugin-api';
import { Config } from '@backstage/config';

export type Chargebacks = {
  BilledCost: number;
  BillingAccountId: string;
  BillingAccountName: string;
  BillingCurrency: string;
  BillingPeriodEnd: string;
  BillingPeriodStart: string;
  ChargeCategory: string;
  ChargeClass: string | null;
  ChargeDescription: string;
  ChargeFrequency: string;
  ChargePeriodEnd: string;
  ChargePeriodStart: string;
  ContractedCost: number;
  EffectiveCost: number;
  InvoiceIssuerName: string;
  ListCost: number;
  PricingQuantity: number;
  PricingUnit: string;
  ProviderName: string;
  PublisherName: string;
  ServiceCategory: string;
  ServiceName: string;
  SubAccountId: string;
  SubAccountName: string;
  Tags: {
    ApplicationId: string;
    ApplicationName: string;
  };
  x_FromCostCenter: string;
  x_IsActive: boolean;
  x_IsShowback: boolean;
  x_WbsId: string;
};

type FinopsHubApiOptions = {
  configApi: Config;
  identityApi: IdentityApi;
};

interface IFinopsHubApi {
  health(): Promise<{ status: string }>;
  getSapProfiles(data: any): Promise<Array<string>>;
  getchargebacks(data: any): Promise<{ results: Chargebacks[] }>;
}

export const finopsHubApiRef = createApiRef<IFinopsHubApi>({
  id: 'plugin.finops-hub',
});

export class FinopsHubApi implements IFinopsHubApi {
  private configApi: Config;
  private identityApi: IdentityApi;

  constructor(options: FinopsHubApiOptions) {
    this.configApi = options.configApi;
    this.identityApi = options.identityApi;
  }

  async health() {
    const backendUrl = this.configApi.getString('backend.baseUrl');
    const token = await this.identityApi.getCredentials();
    const requestUrl = `${backendUrl}/api/finops-hub/health`;
    const response = await fetch(requestUrl, {
      method: 'GET',
      credentials: 'include',
      headers: { Authorization: `Bearer ${token.token}` },
    });

    if (!response.ok || !response.body) {
      throw response.statusText;
    }

    return response.json();
  }

  async getSapProfiles(data: any): Promise<Array<string>> {
    const backendUrl = this.configApi.getString('backend.baseUrl');
    const token = await this.identityApi.getCredentials();
    const requestUrl = `${backendUrl}/api/finops-hub/sap-profiles`;
    const response = await fetch(requestUrl, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${token.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok || !response.body) {
      throw response.statusText;
    }
    return response.json();
  }

  async getchargebacks(data: any) {
    const backendUrl = this.configApi.getString('backend.baseUrl');
    const token = await this.identityApi.getCredentials();
    const requestUrl = `${backendUrl}/api/finops-hub/chargebacks`;
    const requestBody: any = data;
    const response = await fetch(requestUrl, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${token.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok || !response.body) {
      throw response.statusText;
    }

    return response.json();
  }
}
